import { render, staticRenderFns } from "./UpsMyAccountIntegration.vue?vue&type=template&id=6e158be3"
import script from "./UpsMyAccountIntegration.vue?vue&type=script&lang=ts"
export * from "./UpsMyAccountIntegration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports